'use strict';

wbApp.controller('SentEmailStatisticsCtrl', ['$scope', '$translate', '$timeout', 'sentEmailsSvc',
function ($scope, $translate, $timeout, sentEmailsSvc) {

    $scope.fromDate = moment().subtract(6, 'months').toDate();
    $scope.toDate = moment().add(1, 'day').toDate();

    $scope.sentEmailStatistics = {
        type: 'AreaChart',
        data: [[]],
        options: {
            displayExactValues: true,
            isStacked: false,
            chartArea: { top: 20, left: 70, right: 20, height: '85%' },
            legend: {
                position: 'none'
            },
            vAxis: {},
            hAxis: {},
            orientation: 'horizontal'
        }
    };

    function loadData() {
        if ($scope.fromDate && $scope.toDate) {
            sentEmailsSvc.getStatistics($scope.fromDate, $scope.toDate)
                .then(function (data) {
                    $scope.sentEmailStatistics.data = data;
                });
        }
        loaded = true;
    }


    $scope.onDateRangeChanged = function () {
        loadData();
    }

    var isActive = false;
    var loaded = false;

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                if (!loaded) {
                    loadData();
                }
            }
        } else {
            isActive = false;
        }
    });

}]);